module.exports = __webpack_public_path__ + "img/Watery.370296c1.png";